var moment = require("moment");
require("moment/locale/pt-br.js");
require("moment/locale/es.js");
require("moment/locale/fr-ca.js");

require("node_modules/moment-timezone/builds/moment-timezone-with-data.js");

angular.module("core").constant(
    "moment", moment
);



//////////////////
// WEBPACK FOOTER
// ./core/moment/moment.constant.js
// module id = 371
// module chunks = 0